// import { ref } from 'vue'
// import { storeToRefs } from "pinia"
import { useUiElements } from "./../store/uiElements"

export async function uploadFile(file, url) {
	
	const uiStore = useUiElements()

	// set up the request data
	let formData = new FormData()
	formData.append('file', file.file)
	formData.append('percentage', uiStore.pct)

	// track status and upload file
	file.status = 'loading'
	let response = await fetch(url, { method: 'POST', body: formData })

	// change status to indicate the success of the upload request
	file.status = response.ok
	
	return await response.json()
}

export async function uploadFiles(files, url) {
	// console.log("(uploadFiles) files:", files)
	return await Promise.all(files.map((file) => uploadFile(file, url)))
}

// some refactoring due. now that you are suing Pinia store to support the UI across the
// board, there's no need to pass these parameters explicitly
export async function downloadOptimizedFiles() {
	
	const uiStore = useUiElements()
	// const {optimizedImagesCount, optimizationInProgress} = storeToRefs(uiStore)


	return await Promise.all(uiStore.imageVersions.map((img) => {

		// Every option the UI offers is an ImageEngine directive, and the store
		// owns how they compose -- see buildDirectives().
		//
		// Note this no longer writes back to img.width. It used to do
		// `img.width = Math.floor(img.width * pct/100)`, which mutated the
		// store's own variant definition, so the widths compounded on every
		// re-render and only looked right because resetImageVersionArray()
		// happened to rebuild the array first.
		const directives = uiStore.buildDirectives(img)
		const url = `${uiStore.workableImage.url}?imgeng=${directives}`

		// let's remove .jpg/.gif/.png, etc ftom file name
		// https://stackoverflow.com/questions/1818310/regular-expression-to-remove-a-files-extension
		/* THE NAME CAN BE MISSING, and it used to take the whole run down.
		 *
		 * workableImage.name defaults to "" and is overwritten with
		 * thingy[0].name after an upload -- so if that response carries no
		 * name, the field becomes UNDEFINED rather than empty and the substr
		 * below throws. Every version's fetch is then skipped.
		 *
		 * That was invisible until the chain around this function started
		 * being returned: the rejection had nowhere to go and was swallowed,
		 * so a Save simply reused the previous versions and said nothing.
		 * Surfacing it broke a video case that had been passing over the top
		 * of it. A missing name should cost the FILENAME, not the download.
		 *
		 * The staged file is the better fallback anyway: it is what the
		 * visitor chose, and it is what the stage has been calling it. */
		const stagedNow = uiStore.files && uiStore.files[0]
		let tmpFilename = uiStore.workableImage.name
			|| (stagedNow && stagedNow.file && stagedNow.file.name)
			|| "image"
		let noExtensionFilename = tmpFilename.substr(0, tmpFilename.lastIndexOf('.')) || tmpFilename;

		let imageFilename = `${noExtensionFilename}${img.suffix}.${img.format}`

		img.url = url
		img.downloadUrl = `${uiStore.workableImage.url}?imgeng=${uiStore.buildDownloadDirectives(img)}`
		img.filename = imageFilename

		/* THE OLD BLOB IS DROPPED BEFORE THE NEW ONE IS ASKED FOR.
		 *
		 * waitForVersions() in App.vue decides a version is ready by
		 * `v.blob && !v.failed`. On the FIRST render that is right -- there
		 * is no blob until the CDN answers. On a RE-render it was a lie:
		 * every version still held the PREVIOUS render's blob, so the wait
		 * returned instantly and Save handed over the file built for the
		 * setting before last.
		 *
		 * Reported as three saves at 100%, 66% and 50% coming back as
		 * 1280, 1280 and 844 -- each one the previous answer. Measured by
		 * intercepting the anchor: the 100% and 66% downloads were the
		 * SAME blob URL. */
		img.blob = null

		/* RETURNED, so Promise.all waits for it.
		 *
		 * This callback used to fire the fetch and then `return` bare, so
		 * Promise.all resolved over an array of undefined -- on the next
		 * microtask, before a single byte had arrived. Every caller awaits
		 * this function believing the versions are ready. */
		return fetch(url).then((res) => {
			uiStore.optimizedImagesCount++;
			// console.log("1. optimizedImagesCount => ", optimizedImagesCount.value)

			// A number: this is read by formatBytes, compared, and summed.
			// content-length is a string, so "1024" + 512 was a concatenation
			// waiting to happen.
			img.size = Number(res.headers.get("content-length")) || 0
			return res.blob().then((data) => {
				img.blob = window.URL.createObjectURL(data)

				const finish = () => {
					if (uiStore.optimizedImagesCount >= uiStore.imageVersions.length) {
						uiStore.optimizationInProgress = false
					}
				}

				/* The real dimensions, measured off the bytes.
				 *
				 * This used to read them off img.imgEl -- the <img> in the
				 * versions table -- and NOTHING HAS ASSIGNED imgEl since the
				 * table was rewritten. The read stayed, the branch was never
				 * taken, and so naturalWidth was never set on this path: the
				 * table's width and height columns were blank, and every
				 * srcset the page generated said "undefinedw". On the one page
				 * whose entire purpose is producing that markup.
				 *
				 * Measured rather than assumed, and it has to be: ImageEngine
				 * does not upscale, so asking for 1280 from an 800px original
				 * gives an 800px file, and claiming 1280w in a srcset makes
				 * browsers pick the wrong one.
				 *
				 * Off-DOM, like the batch path's measure() in App.vue, so it
				 * does not depend on a row being rendered -- a format this
				 * browser cannot display has no <img> at all.
				 */
				const probe = new Image()
				probe.onload = () => {
					img.naturalWidth = probe.naturalWidth
					img.naturalHeight = probe.naturalHeight
					// Decoding proved it: this browser can show this format.
					uiStore.supportedFormats.add(img.format)
					finish()
				}
				probe.onerror = () => {
					// A format this browser cannot decode still has a size and a
					// blob, and still belongs in the table and the zip. It just
					// cannot contribute a width, and a srcset entry without one
					// is better than a srcset entry that lies.
					finish()
				}
				probe.src = img.blob
			});
		})

	}))
}


export async function fetchImageFromWeb(urlFetcherEndpoint) {

	
	// alert("You want to retrieve "+urlToFetch+"   with  " + urlFetcherEndpoint + "/" + urlToFetch +"\n Ok. I get it")
	// return true
	const uiStore = useUiElements()

	uiStore.awaitingFetchImage = true
	// uiStore.fetchedImageUrl = urlToFetch

	// set up the request data
	let formData = new FormData()
	formData.append('urlToFetch', uiStore.fetchedImageUrl)
	formData.append('percentage', uiStore.pct)



	// let response = await fetch(urlFetcherEndpoint, { method: 'POST', body: formData })

	return await fetch(urlFetcherEndpoint, { method: 'POST', body: formData })

	/* 
	// in spite of the name json() returns a JS object and not JSON
	let responseObject = await response.json()

	console.log("responseObject.error: "+ responseObject.Error)
	if (responseObject.Error) {
		console.log(responseObject.Error)
		uiStore.awaitingFetchImage = false
		uiStore.fetchedImageError = responseObject.Error
		console.log("there was an error returning FALSE")
		return false
	}


	uiStore.workableImage.name = responseObject.name
	uiStore.workableImage.size = responseObject.size
	// uiStore.workableImage.width = justOnefileReally[0].width
	// uiStore.workableImage.height = justOnefileReally[0].height
	uiStore.workableImage.url = uiStore.s3urlRoot + responseObject.name
	uiStore.workableImage.ready = true

	// console.log("uiStore.optimizationInProgress", uiStore.optimizationInProgress)
   
	//downloadOptimizedFiles(uiStore.imageVersions, uiStore.workableImage, pct)
	downloadOptimizedFiles()
		.then(() => {
			// console.log("All images loaded")
			uiStore.showDownloadables = true
		})
	
	uiStore.awaitingFetchImage = false
	uiStore.imageFromInternetModal = false
	console.log("About to return TRUE")
	return true
   */
}

export default function createUploader(baseUrl) {

	const uploadUrlEndpoint = baseUrl + "/upload"
	
	const urlFetcherEndpoint = baseUrl + "/fetchImage"

	return {
		uploadFile: function (file) {
			return uploadFile(file, uploadUrlEndpoint)
		},
		// Luca. Added percentage parameter.
		uploadFiles: function (files) {
			return uploadFiles(files, uploadUrlEndpoint)
		},
		// Luca, added download optimized files
		downloadOptimizedFiles: function() {
			return downloadOptimizedFiles()
		},

		// Luca, fetch Image through URL
		fetchImageFromWeb: function() {
			return fetchImageFromWeb(urlFetcherEndpoint)
		},
	}
}
